const indexItems = [
  { name: '热血漫画', count: '3,286部', icon: 'ri-fire-line', color: 'bg-primary-50 text-primary-600', desc: '战斗、冒险、成长，点燃你的热血之魂' },
  { name: '恋爱漫画', count: '2,851部', icon: 'ri-heart-line', color: 'bg-accent-50 text-accent-600', desc: '甜宠、虐恋、纯爱，心动每一页' },
  { name: '奇幻漫画', count: '2,463部', icon: 'ri-magic-line', color: 'bg-secondary-50 text-secondary-600', desc: '异世界、魔法、传说，无限想象' },
  { name: '悬疑漫画', count: '1,927部', icon: 'ri-search-eye-line', color: 'bg-primary-50 text-primary-600', desc: '推理、反转、谜题，步步惊心' },
  { name: '搞笑漫画', count: '2,104部', icon: 'ri-emotion-laugh-line', color: 'bg-accent-50 text-accent-600', desc: '轻松、幽默、治愈，笑到停不下来' },
  { name: '都市漫画', count: '1,683部', icon: 'ri-building-line', color: 'bg-secondary-50 text-secondary-600', desc: '职场、生活、现实，都市里的故事' },
  { name: '古风漫画', count: '1,426部', icon: 'ri-ancient-pavilion-line', color: 'bg-primary-50 text-primary-600', desc: '仙侠、宫廷、江湖，古韵悠长' },
  { name: '科幻漫画', count: '1,158部', icon: 'ri-rocket-line', color: 'bg-accent-50 text-accent-600', desc: '未来、机甲、太空，探索未知' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">分类索引</h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">按题材快速找到你想看的<strong>免费漫画全集</strong>，精准定位不迷路</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.name}
              href="#ranking"
              className="flex items-start gap-4 p-4 md:p-5 rounded-xl border border-background-200/60 bg-background-50 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${item.color}`}>
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2 mb-1">
                  <h3 className="text-sm md:text-base font-heading text-foreground-900 whitespace-nowrap">{item.name}</h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}</span>
                </div>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}